import React from "react"

import * as S from "./custom-button.styles"
import PropTypes from "prop-types"
import { Link } from "gatsby-link"

const CustomButton = props => {
  const { fullWidth, className, children, href, loading } = props

  const internal = /^\/(?!\/)/.test(href)

  return (
    <S.CustomButton
      className={`custom-button ${className}`}
      disableElevation
      fullWidth={fullWidth ? true : null}
      variant="contained"
      to={href}
      LinkComponent={href && internal ? Link : href ? "a" : null}
      loading={loading}
      {...props}
    >
      {children}
    </S.CustomButton>
  )
}

CustomButton.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
  fullWidth: PropTypes.bool,
}

export default CustomButton
